import script from "./pc-module-case-1.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-case-1.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-case-1.vue?vue&type=style&index=0&id=0d7a032a&lang=scss"

const __exports__ = script;

export default __exports__